// extracted by mini-css-extract-plugin
export default {"header_wrapper":"ListDepartemen_header_wrapper__rPdJX","header_container":"ListDepartemen_header_container__0poI4","table_wrapper":"ListDepartemen_table_wrapper__XlkWx"};